import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yoyakuDateFilterPipe'
})
export class YoyakuDateFilterPipe implements PipeTransform {

  // 予約のリストから日付×時間軸のレコードだけ抽出する
  transform(list: any[],p_date,p_timeaxis_id): any[] {
    return list.filter(item => ((item.yoyaku_date == p_date) && (item.m_timeaxis_id == p_timeaxis_id)));
  }
  
}


// WEBPACK FOOTER //
// ./src/app/pipes/yoyaku-date-filter.pipe.ts